// frontend/src/components/common/Card.tsx
import React, { ReactNode } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface CardProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  className?: string;
  customClasses?: string;
  noPadding?: boolean;
  footer?: ReactNode;
  headerAction?: ReactNode;
}

const Card: React.FC<CardProps> = ({
  children,
  title,
  subtitle,
  className = '',
  customClasses = '',
  noPadding = false,
  footer,
  headerAction
}) => {
  const { themeClasses, darkMode } = useTheme();
  
  // Use custom classes if provided, otherwise use theme-based styling
  const cardClasses = customClasses || `${themeClasses.cardBg} border ${darkMode ? 'border-gray-700' : 'border-gray-200'}`;
  
  return (
    <div className={`rounded-lg shadow-sm overflow-hidden ${cardClasses} ${className}`}>
      {/* Card Header (if title or subtitle or headerAction is provided) */}
      {(title || subtitle || headerAction) && (
        <div className={`px-4 py-3 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
          <div className="flex items-center justify-between">
            <div>
              {title && (
                <h3 className={`text-lg font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className={`mt-1 text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                  {subtitle}
                </p>
              )}
            </div>
            {headerAction && (
              <div>{headerAction}</div>
            )}
          </div>
        </div>
      )}
      
      {/* Card Body */}
      <div className={noPadding ? '' : 'p-4'}>
        {children}
      </div>
      
      {/* Card Footer */}
      {footer && (
        <div className={`px-4 py-3 border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;